
  <fuse-card class="w-full flex flex-col p-4">    
      <div class="flex items-center justify-between mb-4">
        <div class="text-lg font-bold text-gray-800 flex items-baseline">
          Analyse en cours
        </div>
        <div class="text-sm text-gray-500">Traitement automatique</div>
      </div>

      <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>

      <div class="mt-4 grid grid-cols-2 gap-3">
        <div class="p-3 bg-green-50 rounded flex items-center">
          <mat-icon class="text-green-600">check_circle</mat-icon>
          <div class="ml-3 text-sm font-medium">Extraction des données</div>
        </div>
        <div class="p-3 bg-white rounded border border-gray-200 flex items-center">
          <mat-icon class="text-gray-400 animate-spin">autorenew</mat-icon>
          <div class="ml-3 text-sm text-gray-500">Vérification de conformité</div>
        </div>
      </div>
  </fuse-card>